{
  "farmUsersListHelpBodyText": "Farm users are individuals who have been invited to join a farm account. Farm users can view and manage all devices associated with the farm account, as long as they have the correct farm-user permissions. Farm users can also be assigned specific permissions by administrators of the farm, which determine what actions they can take on the farm account.\n\nTap 'Manage Permissions' to view and edit the permissions of each farm user.",
  "farmUsersListHelpTitle": "About Farm Users",
  "farmUsersListLinkTo": "Manage Farm Users",
  "farmUsersListListEmpty": "You are the only user of this farm.",
  "farmUsersListSubtitle": "Manage Permissions",
  "farmUsersListTitle": "Manage Farm Users",
  "managePermissionsLink": "Manage Permissions",
  "managePermissionsTitle": "Manage Permissions"
}
